import React from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { QRCodeSVG } from 'qrcode.react';
import { isMobile, APP_STORE_URL } from '../utils/platformDetect';
import { trackEvent } from '../utils/promoTracking';
import { useLanguage } from '../contexts/LanguageContext';
import './AppLandingSection.css';

function AppLandingSection() {
  const { t } = useLanguage();

  const handleCTA = () => {
    trackEvent('landing-section-click');
    window.open(APP_STORE_URL, '_blank', 'noopener');
  };

  const features = [
    t('appPromoFeature1'),
    t('appPromoFeature2'),
    t('appPromoFeature3'),
  ];

  return (
    <section className="app-landing-section" aria-label={t('appPromoTitle')}>
      <div className="app-landing-inner">
        {/* Phone screenshots */}
        <div className="app-landing-screenshots">
          <div className="screenshot-frame screenshot-back">
            <img src="/app-screenshot-detail.png" alt="Station detail view" />
          </div>
          <div className="screenshot-frame screenshot-front">
            <img src="/app-screenshot-map.png" alt="Map view" />
          </div>
        </div>

        {/* Content */}
        <div className="app-landing-content">
          <h2>{t('appPromoTitle')}</h2>
          <ul className="app-landing-features">
            {features.map((feature, i) => (
              <li key={i}>
                <IoCheckmarkCircle size={20} className="feature-check" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
          <div className="app-landing-actions">
            {isMobile() ? (
              <button className="app-landing-cta" onClick={handleCTA}>
                <img
                  src="/app-store-badge.svg"
                  alt={t('downloadApp')}
                  className="landing-store-badge"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'inline';
                  }}
                />
                <span style={{ display: 'none' }} className="cta-fallback-btn">{t('downloadApp')}</span>
              </button>
            ) : (
              <div className="app-landing-qr">
                <QRCodeSVG value={APP_STORE_URL} size={100} level="M" bgColor="transparent" />
                <span className="landing-qr-label">{t('scanToDownload')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AppLandingSection;
